// extracted by mini-css-extract-plugin
export default {"item":"PosterCard_item__Uydxm"};